import React, { useMemo } from 'react';
import RoleDashboardTemplate from './RoleDashboardTemplate';
import { useAuth } from '../../context/AuthContext';
import { buildRoleWorkspaceModules } from '../../config/roleWorkspaceConfig';

const FinanceDashboardPage = () => {
  const auth = useAuth();
  const modules = useMemo(() => buildRoleWorkspaceModules('finance_manager', auth), [auth]);

  return (
    <RoleDashboardTemplate
      title="Finance Dashboard"
      subtitle="Organization-level financial control center for revenue, expenses, and reporting."
      modules={modules}
    />
  );
};

export default FinanceDashboardPage;
